module.exports = __webpack_public_path__ + "themes/defaultColorPalette.js";